import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

import Img from 'retired/Img';
import CheckCircleIcon from 'assets/icons/check-circle.svg';
import { primaryBlue, gray } from 'utils/color-styles';

const getStyles = ({ active, completed, disabled }, { stepper }) => {
  const iconColor = primaryBlue;
  const inactiveIconColor = gray;
  const disabledTextColor = gray;
  const orientation = stepper?.orientation || 'horizontal';

  const styles = {
    root: {
      height: orientation === 'horizontal' ? 72 : 64,
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      paddingLeft: 14,
      paddingRight: 14,
    },
    icon: {
      color: iconColor,
      display: 'block',
      fontSize: 28,
      fontWeight: 300,
      width: 28,
      height: 28,
    },
    iconContainer: {
      paddingRight: 28,
    },
  };

  if (active) {
    styles.root.fontWeight = 500;
  }

  if (!completed && !active) {
    styles.icon.color = inactiveIconColor;
  }

  if (disabled) {
    styles.icon.color = inactiveIconColor;
    styles.root.color = disabledTextColor;
    styles.root.cursor = 'default';
  }

  return styles;
};

const renderIcon = (completed, icon, styles) => {
  const iconType = typeof icon;

  if (iconType === 'number' || iconType === 'string') {
    if (completed) {
      return <Img src={CheckCircleIcon} style={styles.icon} alt="" />;
    }

    return (
      <SvgIcon style={styles.icon}>
        <circle cx="12" cy="12" r="10" />
        <text x="12" y="16" textAnchor="middle" fontSize="12" fill="#fff">
          {icon}
        </text>
      </SvgIcon>
    );
  }

  return icon;
};

const StepLabel = (props, context) => {
  const {
    active, // eslint-disable-line no-unused-vars
    children,
    completed,
    icon: userIcon,
    iconContainerStyle,
    last, // eslint-disable-line no-unused-vars
    style,
    ...other
  } = props;

  const styles = getStyles(props, context);
  const icon = renderIcon(completed, userIcon, styles);

  return (
    <span style={styles.root} {...other}>
      {icon && <span style={styles.iconContainer}>{icon}</span>}
      {children}
    </span>
  );
};

StepLabel.muiName = 'StepLabel';

StepLabel.propTypes = {
  /**
   * Sets active styling. Overrides disabled coloring.
   */
  active: PropTypes.bool,
  /**
   * The label text node
   */
  children: PropTypes.node,
  /**
   * Sets completed styling. Overrides disabled coloring.
   */
  completed: PropTypes.bool,
  /**
   * Sets disabled styling.
   */
  disabled: PropTypes.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
  /**
   * Override the inline-styles of the icon container element.
   */
  iconContainerStyle: PropTypes.object,
  /**
   * @ignore
   */
  last: PropTypes.bool,
  /**
   * Override the inline-style of the root element.
   */
  style: PropTypes.object,
};

StepLabel.contextTypes = {
  stepper: PropTypes.object,
};

export default StepLabel;
